<script lang="ts">
import { NotFoundComponent } from "./not-found.ts";
export default NotFoundComponent;
</script>
<template>
    <base-header type="white"></base-header>
    <main class="p-d-flex p-flex-column">
        <div class="p-d-flex p-jc-center not-found--img-container">
            <img src="/img/not-found.png" class="not-found--img" />
        </div>
        <div class="p-d-flex p-jc-center not-found--text-container">
            <div class="not-found--text">
                <i18n-t keypath="common.pageNotFound" />
            </div>
        </div>
        <div class="p-d-flex p-jc-center not-found--text-second-container">
            <div class="not-found--text-second">
                <i18n-t keypath="common.pageNotExist" />
            </div>
        </div>
    </main>
    <base-footer></base-footer>
</template>
<style scoped>
.not-found--img-container {
    margin-top: 71px;
}

.not-found--img {
    height: 363px;
    width: calc(min(100vw, 412px));
}

.not-found--text-container {
    margin-top: 25px;
}

.not-found--text {
    font-family: var(--font-family);
    font-size: 28px;
    font-style: normal;
    font-weight: 500;
    line-height: 34px;
    letter-spacing: 0.01em;
    text-align: center;
    color: #283747;
}

.not-found--text-second {
    font-family: var(--font-family);
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: center;
    color: #627690;
}

.not-found--text-second-container {
    margin-top: 10px;
}
</style>
